import React from 'react'
import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'
import type { OnShapeCommitted } from '../types/on-shape-committed'
import { replaceFontFamilies } from '../helpers/replace-font-families'

/**
 * Font fallback shared by `MissingFontsChecker` and `BlockedFontsChecker`: every text frame using
 * one of `familyIds` is switched to the default font in the manager and committed, so the change is
 * persisted and undoable like any other text edit.
 */
export function fallBackTextShapeFonts(
  textShapes: ShapeData[],
  familyIds: ReadonlySet<number>,
  shapeManagerRef: React.RefObject<ShapeManagerRef | null>,
  onShapeCommitted: OnShapeCommitted | undefined
): void {
  for (const shape of textShapes) {
    const { paragraphs: updatedParagraphs, hasChanges } = replaceFontFamilies(
      shape.paragraphs,
      familyIds
    )

    if (hasChanges) {
      const beforeParagraphs = shape.paragraphs

      shapeManagerRef.current?.updateShape(shape.id, { paragraphs: updatedParagraphs })

      const updatedShape = shapeManagerRef.current?.getShapes().find((s) => s.id === shape.id)

      if (updatedShape && onShapeCommitted) {
        onShapeCommitted(updatedShape, 'update', {
          before: { paragraphs: beforeParagraphs },
          after: { paragraphs: updatedParagraphs },
        })
      }
    }
  }
}
